export default {
  SET_PAYMENT_ACCOUNTS: 'SET_PAYMENT_ACCOUNTS',
  SET_PAYMENT_ACCOUNTS_WITH_PRIMARY: 'SET_PAYMENT_ACCOUNTS_WITH_PRIMARY',
  GET_PAYMENT_ACCOUNTS: 'GET_PAYMENT_ACCOUNTS',
  TOGGLE_PAYMENT_ACCOUNT_DIALOG: 'TOGGLE_PAYMENT_ACCOUNT_DIALOG',
  HIDE_PAYMENT_ACCOUNT_DIALOG: 'HIDE_PAYMENT_ACCOUNT_DIALOG',
  REMOVE_PAYMENT_ACCOUNT: 'REMOVE_PAYMENT_ACCOUNT',
  DELETE_PAYMENT_ACCOUNT: 'DELETE_PAYMENT_ACCOUNT',
  PAYMENT_ACCOUNTS_ERROR: 'PAYMENT_ACCOUNTS_ERROR',
  SET_DEFAULT_PAYMENT: 'SET_DEFAULT_PAYMENT',
  SET_DEFAULT_PAYMENT_ACCOUNT: 'SET_DEFAULT_PAYMENT_ACCOUNT',
  SET_DEFAULT_PAYMENT_AND_UPDATE: 'SET_DEFAULT_PAYMENT_AND_UPDATE',
  ADD_NEW_PAYMENT_ACCOUNT_CALL: 'ADD_NEW_PAYMENT_ACCOUNT_CALL',
  ADD_NEW_PAYMENT_ACCOUNT: 'ADD_NEW_PAYMENT_ACCOUNT',
  UPDATE_PAYMENT_ACCOUNT_CALL: 'UPDATE_PAYMENT_ACCOUNT_CALL',
  SET_SELECTED_PAYMENT_ACCOUNT: 'SET_SELECTED_PAYMENT_ACCOUNT'
};


// WEBPACK FOOTER //
// ./src/account/actions/payment-accounts-action-types.js